module.exports = __webpack_public_path__ + "img/terms-conditions-m.eeec4ad.webp";